<template>
    <div class="w-100 h-100 d-flex flex-column bg-white">
        <div class="p-2 d-flex flex-row" style="gap: 10px">
            <input type="text" class="form-control" placeholder="Search User ..." v-model="search" @keyup.enter="loadUsers()"/>
            <button class="btn btn-dark" @click="loadUsers()"  >Retrieve</button>
            <button class="btn btn-success" @click="createUser()">Create</button>
        </div>
        <div class="flex-1 position-relative w-100 h-100">
            <div class="position-absolute w-100 h-100 overflow-auto">
                <table class="table table-hover">
                    <thead>
                        <th class="bg-light fw-500">User ID</th>
                        <th class="bg-light fw-500">Username</th>
                        <th class="bg-light fw-500">Department</th>
                        <th class="bg-light fw-500">Priveledge</th>
                        <th class="bg-light fw-500">Company Code</th>
                    </thead>
                    <tbody v-if="users.length">
                        <tr class="cp" v-for="(user, i) in users" :key="i" @click="selectUser(user)">
                            <td class="fs-14">{{user.user_id}}</td>
                            <td class="fs-14">{{user.user_name}}</td>
                            <td class="fs-14">{{user.department}}</td>
                            <td class="fs-14">{{user.priveledge}}</td>
                            <td class="fs-14">{{user.company_code}}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="5" class="text-center">Loading</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!--USER MODAL-->
    <div class="sidebar-modal p-3" :class="show == true ? 'show' : ''" >
        <h3>{{create ? 'Create' : 'Update'}} User Details</h3> 
        <div class="row">
          
            <div class="form-group col-12">
                <label>User ID</label>
                <input type="text" class="form-control" v-model="selected_user.user_id" :disabled="!create" />
            </div>
            <div class="form-group col-12">
                <label>Username</label>
                <input type="text" class="form-control" v-model="selected_user.user_name" :disabled="!create" />
            </div>
            <div class="form-group col-12">
                <label>Priveledge</label> 
                <select class="form-control" v-model="selected_user.priveledge">
                    <option v-for="(value, key) in priveledge" :key="key" :value="key">{{value}}</option>
                </select>
            </div>

            <div class="form-group col-12">
                <label>Password</label>
                <input type="password" class="form-control" v-model="selected_user.password" />
            </div>

            <div class="form-group col-12">
                <label>Status</label>
                <select class="form-control" v-model="selected_user.status">
                    <option v-for="(value, key) in status" :key="key" :value="key">{{value}}</option>
                </select>
            </div>

            <div class="form-group col-12">
                <label>Department</label>
                <select class="form-control" v-model="selected_user.department">
                    <option v-for="(value, key) in departments" :key="key" :value="value.code">{{value.name}}</option>
                </select>
            </div>

            <div class="form-group col-12">
                <label>Company</label> 
                <select class="form-control" v-model="selected_user.company_code">
                    <option v-for="(value, key) in companies" :key="key" :value="value.company_code">{{value.company_name}}</option>
                </select>
            </div>

            <div class="form-group col-12 d-flex flex-row" style="gap: 10px">
                <button class="btn btn-dark btn-lg" @click="submitUser">Submit</button>
                <button class="btn btn-lg" @click="close">Close</button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return {
            users: [],
            search: '',

            //<!--USER MODAL-->
            priveledge: {
                'S' : 'Super User',
                'U' : 'User'
            },
            status: {
                'ATV' : 'Active',
                'ITV' : 'Inactive'
            },
            departments: [],
            show: false,
            selected_user: {},
            create: false,
            companies:[]
        }
    },
    methods: {
        async loadUsers(){
            this.users = true;
            await this.$axios.get('/user?search='+this.search)
                .then(response =>{
                    let data = response.data;
                    this.users = data;
                })
                .catch(error=>{
                    this.$jlalert.show(error);
                })
        },
    
        //<!--USER MODAL-->
        async loadDepartments() {
            await this.$axios.get('/departments')
                    .then(res => {
                        this.departments = res.data;
                    })
                    .catch(err => {
                        console.error(err);
                        this.departments = [];
                    })
        },
        async loadCompany() {
            await this.$axios.get('/companies')
                    .then(res => {
                        this.companies = res.data;
                    })
                    .catch(err => {
                        console.error(err);
                        this.companies = [];
                    })
        },
        async submitUser(){ 
                //update user
            await this.$axios.post('/user',this.$qs.stringify({selected_user:this.selected_user,create:this.create}))
                .then(response =>{
                    let data = response.data;
                    if (data == -1){
                        this.$jlalert.show('User ID is already exists');
                    }
                    else{
                        this.$jlalert.show(data,false);
                    } 
                })
                .catch(error=>{
                    this.$jlalert.show(error);
                })
                this.loadUsers();
                this.loadDepartments();
        } ,
        close() {
            this.show = false;
            this.selected_user = {};
            this.create = false;
        },
        selectUser(user) {
            // console.log(user);
            this.selected_user = user;
            this.show = true;
            this.create = false;
        },
        createUser() {
            this.show = true;
            this.selected_user = {};
            this.create = true;
        }
    },
    mounted(){
        this.loadUsers();
        this.loadCompany();
        //<!--USER MODAL-->
        this.loadDepartments();
    },
    watch: {
        "search": function(newValue) {
            if(newValue == '') this.loadUsers();
        }
    }
}
</script>

<style scoped>
.sidebar-modal {
    width: 50%;
    height: 100%;
    position: fixed;
    right: -100%;
    background: #fff;
    top: 0;
    z-index: 10;
    border: 1px solid #c9c9c95e;
    transition: 0.3s all ease-in-out;
}

.show {
    right: 0
}
</style>